var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 8.92L10.95 0.42C10.39 -0.14 9.47 -0.14 8.91 0.42L0.42 8.92C-0.14 9.48 -0.14 10.4 0.42 10.96L4.55 15.09V11.97C4.55 10.3 5.91 8.94 7.58 8.94H12.32L10.7 7.32C10.31 6.93 10.31 6.3 10.7 5.91C11.09 5.52 11.72 5.52 12.11 5.91L15.43 9.23C15.52 9.32 15.6 9.43 15.65 9.56C15.75 9.8 15.75 10.08 15.65 10.32C15.6 10.44 15.53 10.55 15.43 10.65L12.11 13.98C11.91 14.18 11.66 14.27 11.4 14.27C11.14 14.27 10.89 14.17 10.69 13.98C10.3 13.59 10.3 12.96 10.69 12.57L12.31 10.95H7.57C7 10.95 6.54 11.41 6.54 11.98V17.1L8.9 19.46C9.46 20.02 10.38 20.02 10.94 19.46L19.43 10.97C19.99 10.41 19.99 9.49 19.43 8.93L19.45 8.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.f6526433e798688069ed6d4791fc578b.svg";
export { ForwardRef as ReactComponent };